module.exports = "div.bubble {\n  position: absolute;\n  right: 10px;\n  bottom: 20px;\n  width: 9px;\n  height: 9px;\n  border-radius: 50%;\n  background-color: #ea148c;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/chat-unread-bubble/chat-unread-bubble.component.less
// module id = 590
// module chunks = 0